import {Component, Input, OnInit} from '@angular/core'
import {FormGroup} from '@angular/forms'

@Component({
  selector: 'dmmp-form-checkbox',
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent implements OnInit {
  @Input() field
  @Input() identifier
  @Input() terms
  @Input() group: FormGroup
  openModal: boolean

  constructor() {
  }

  ngOnInit() {
  }
}
